import { TffBookingSource } from '@tff/types/tff';

export const isNdcBooking = (bookingSource: TffBookingSource | string) => {
  return bookingSource.includes('NDC') || bookingSource.includes('AMA');
};

export const isNskBooking = (bookingSource: TffBookingSource | string) => {
  return bookingSource.includes('NSK');
};
